import { SERVER_URI } from '../Constant/server';
import { apiGet, apiPost, apiPut } from '../utils/axios';

const BASE_URI = SERVER_URI + '/get-designations';
const ADD_DESIGNATION_LIST = SERVER_URI + '/designations';
const CHANGE_DESIGNATION_STATUS = SERVER_URI + '/change-designations-status/';
const UPDATE_DESIGNATION = SERVER_URI + '/designations/';

export default {

  bindDesignation:async function(paylaod)
  {

    return apiPost(BASE_URI,paylaod)
    
  },

  addDesignationList: async function (paylaod) {
    return apiPost(ADD_DESIGNATION_LIST, paylaod);
  },
  changeDesignationStatus: async function (id) {
    return apiGet(CHANGE_DESIGNATION_STATUS + id);

  },
  updateDesignation: async function (id,payload) {
    return apiPut(UPDATE_DESIGNATION +id,payload)
  }

};